import { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Message } from 'semantic-ui-react';
import { threeDotSeparator } from '../utils';
import { HtmlService } from '../services';
import './styles.scss';

let NotificationMessage = ({
  title,
  message,
  style = 'warning',
  width,
  classNames,
  updateNotificationReadStatus = null,
  t,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const contentRef = useRef(null);

  // react-show-more-text measures node.innerText for its own line-wrapping
  // math and re-renders plain-text spans, silently discarding any HTML
  // formatting (bold/italic/lists) — CSS line-clamp + scrollHeight check
  // preserves the message's real markup instead.
  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, [message]);

  return (
    <div
      className={`notify-message pre-line ${classNames ? classNames : ''}`}
      style={{
        width: width ? width : '100%',
        margin: '0rem',
      }}
    >
      <Message
        negative={style === 'warning'}
        className={style}
        onDismiss={
          updateNotificationReadStatus !== null
            ? () => {
                updateNotificationReadStatus();
              }
            : false
        }
      >
        <div>
          <div className="notification-title">
            {threeDotSeparator({
              name: title,
              length: 52,
              isPopUp: false,
            })}
          </div>

          <div
            ref={contentRef}
            className={`notify-message-content${
              expanded ? '' : ' notify-message-content--clamped'
            }`}
          >
            {HtmlService.convertToInnerHtml({
              children: message,
              richText: true,
              htmlConversionStyle: 'para',
              returnAs: 'html',
            })}
          </div>
          {isTruncated || expanded ? (
            <span
              className="show-more-less-clickable"
              onClick={() => setExpanded((prevExpanded) => !prevExpanded)}
            >
              {expanded ? t('common.read_less') : t('common.read_more')}
            </span>
          ) : null}
        </div>
      </Message>
    </div>
  );
};

NotificationMessage = withTranslation()(NotificationMessage);
export { NotificationMessage };
